import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Badge} from '@/components/ui/badge/Badge'

/** A labelled filter cell ("Stato", "Periodo") that shares the toolbar row width evenly. */
export const StyledFilterField = styled(Flexbox)(
    () => css`
        flex: 1 1 0;
        min-width: 150px;
    `
)

/** Chip representing a single *applied* filter, with a trailing ✕ to clear it. */
export const StyledRemovableChip = styled(Badge)(
    ({theme: {spacing}}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${spacing}px;
        cursor: pointer;
        user-select: none;

        svg {
            width: 12px;
            height: 12px;
        }
    `
)
